import { ParkSitesLayout } from '.'

export const ParkSites = () => {
  return <ParkSitesLayout />
}
